import Auth from '../modules/Authentication'
import {apiUrl} from '../variables/index'
import {handleErrors, handleResponse} from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Search {
  constructor() {
    this.auth = new Auth()
  }

  search = q => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}search/?q=${q}`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  }
}
